(function () {
  document.querySelectorAll('[data-brand-bleuetieres-carousel]').forEach((root) => {
    const track = root.querySelector('[data-brand-blu-track]');
    const prevBtn = root.querySelector('[data-brand-blu-prev]');
    const nextBtn = root.querySelector('[data-brand-blu-next]');
    const n = track?.children.length || 0;
    if (!track || n === 0) return;

    let i = 0;
    const apply = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
    };

    prevBtn?.addEventListener('click', () => {
      i = (i - 1 + n) % n;
      apply();
    });
    nextBtn?.addEventListener('click', () => {
      i = (i + 1) % n;
      apply();
    });
    apply();
  });
})();
